<template>
    <v-container class="mx-0 px-0 py-0 mb-2">
        <v-row>
            <v-col xs="12" sm="12" md="12" lg="6" class="pl-5 pr-5 mt-2">
                <upcoming-events-card
                    :upcomingEvent="item[0]"
                />         
            </v-col>
            <v-col v-if="item.length== 2" xs="12" sm="12" md="12" lg="6" class="pl-5 pr-5 mt-2">
                <upcoming-events-card
                    :upcomingEvent="item[1]"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import UpcomingEventsCard from '@/components/upcomingEventsCards/UpcomingEventsCard.vue'

export default {
    name: 'UpcomingEventsScrollItem',
    components: {
        UpcomingEventsCard
    },
    props: {
        item: Array
    }
}
</script>